var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(" WORKFLOW REQUESTOR ")
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_workflow.title.$error } },
        [
          _c("label", [_vm._v(" Workflow Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Workflow Title" },
            model: {
              value: _vm.$v.data_workflow.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_workflow.title, "$model", $$v)
              },
              expression: "$v.data_workflow.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_workflow.form.$error } },
        [
          _c("label", [_vm._v(" Select Form ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsForm,
              "is-async": true,
              "cache-option": false,
              placeholder: "Choose Form",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_workflow.form.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_workflow.form, "$model", $$v)
              },
              expression: "$v.data_workflow.form.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_workflow.rule.$error } },
        [
          _c("label", [_vm._v(" Select Rule ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsRule,
              "is-async": true,
              "cache-option": false,
              placeholder: "Choose Rule",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_workflow.rule.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_workflow.rule, "$model", $$v)
              },
              expression: "$v.data_workflow.rule.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_workflow.stage.$error } },
        [
          _c("label", [_vm._v(" Select Stage ")]),
          _vm._v(" "),
          _c("j-multi-select", {
            attrs: {
              options: _vm.list_stage,
              placeholder: "Choose Stage",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_workflow.stage.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_workflow.stage, "$model", $$v)
              },
              expression: "$v.data_workflow.stage.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeWorkflow }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveWorkflow } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47ae3118", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ae3118","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jWorkflowReqSetup.vue
// module id = null
// module chunks = 